import { useEffect, type ReactNode } from "react";

// Panel que entra por la derecha (Kevin, 10-oct-2026: «la sección de editar me parece correcta»). En la compu
// ocupa 440 px a la derecha; en el celular, la pantalla entera. Se cierra con la X, con Escape o tocando
// fuera. Patrón tomado del research `docs/research/2026-10-10-botones-por-fila`: la fila informa y una sola
// puerta («Editar») lleva a todo lo que se puede cambiar.
export function PanelLateral({ titulo, subtitulo, onCerrar, children }: { titulo: string; subtitulo?: string | undefined; onCerrar: () => void; children: ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCerrar();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCerrar]);

  return (
    <div className="fixed inset-0 z-[60] flex justify-end bg-ink-surface/40" onClick={onCerrar}>
      <div
        role="dialog"
        aria-label={titulo}
        className="flex h-full w-full flex-col bg-card shadow-[0_10px_30px_rgba(36,29,26,0.25)] sm:max-w-[440px] sm:border-l sm:border-line"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 border-b border-line-row px-5 py-4">
          <div className="min-w-0">
            <h2 className="truncate text-[16.5px] font-bold text-ink">{titulo}</h2>
            {subtitulo && <p className="mt-0.5 truncate text-[12.5px] text-ink-2">{subtitulo}</p>}
          </div>
          <button
            onClick={onCerrar}
            aria-label="Cerrar"
            className="min-h-[44px] min-w-[44px] shrink-0 rounded-[9px] text-[20px] leading-none text-ink-2 hover:bg-hover-btn"
          >
            ×
          </button>
        </div>
        <div className="flex flex-1 flex-col gap-5 overflow-y-auto px-5 py-4">{children}</div>
      </div>
    </div>
  );
}

// Un bloque dentro del panel: título chico y su contenido. `peligro` lo separa y lo pinta para las acciones
// que dejan a alguien sin acceso.
export function BloquePanel({ titulo, peligro, children }: { titulo: string; peligro?: boolean; children: ReactNode }) {
  return (
    <section className={peligro ? "mt-auto flex flex-col gap-2.5 border-t border-line-row pt-4" : "flex flex-col gap-2.5"}>
      <h3 className={peligro ? "text-[11px] font-bold uppercase tracking-[0.1em] text-accent-ink" : "text-[11px] font-bold uppercase tracking-[0.1em] text-ink-2"}>
        {titulo}
      </h3>
      {children}
    </section>
  );
}
